<template>
    <div class="search-container">
<!--        <div class="navigation">-->
<!--            <p class="hisTips-1">购买招标文件快速入口</p>-->
<!--            <van-grid clickable :column-num="3" :gutter="1">-->
<!--                <van-grid-item-->
<!--                        v-for="(i,index) in quickEnterList"-->
<!--                        :key="index"-->
<!--                        @click="itemClick(i)"-->
<!--                >-->
<!--                    <van-icon size="30px" :color="i.color" name="coupon-o"/>-->
<!--                    <div class="search-quick-text">{{i.text}}</div>-->
<!--                </van-grid-item>-->
<!--            </van-grid>-->
<!--        </div>-->
        <van-divider/>
        <div class="showHis">
            <p class="hisTips">搜索记录</p>
            <template v-for="(his, i) in historyList">
               <van-cell :title="his" icon="clock-o" :key="i" @click="hisSearch(his)"/>
            </template>
        </div>
    </div>
</template>

<script>
    import {
        Grid,
        GridItem,
        Icon,
        Divider,
        Cell,
        CellGroup,
        Toast
    } from 'vant';
    import Menus from '@/assets/json/menu1.js';
    import api from '@/api';
    import store from '@/store';

    export default {
        components: {
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Icon.name]: Icon,
            [Divider.name]: Divider,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Toast.name]: Toast
        },
        data() {
            return {
                tabMenu: Menus,
                historyList: [],
                searchVal: "",
            };
        },
        created() {
            this.getHistory();
        },
        mounted(){

        },
        methods: {
            // itemClick(item){
            //     // console.log(item)
            //     this.$router.replace({
            //         name:"tender",
            //         query:{
            //             type:item.type
            //         }
            //     })
            // },
            async getHistory() {
                const param = {
                    token: store.getters.token
                }
                const res = await api.search.getHistory(param);
                const { data } = res;
                if(data.length){
                    this.historyList = data.slice(-10)
                    
                }
            },
            hisSearch(obj) {
                this.searchVal = obj;
                this.$emit('func',this.searchVal)
            }
        }
    }
</script>
<style lang="less">
    .search-container {
        .tender-item {
            color: gray;
            .van-grid-item__content {
                border-radius: 10px;
                padding: 2px 5px;
            }

        }
        .van-grid-item__text {
            color: inherit;
            font-size: 2.2vw;
        }
        .van-grid-item__content--surround::after, .van-grid-item__content::after {
            border-width: 0!important;
        }
        .search-quick-text{
            margin-top: 5px;
        }
        .hisTips-1{
            margin: 15px;
            margin-bottom: 0;
            color: #323233;
            font-size: 3.73333vw;
        }
        .hisTips{
            margin: 15px;
            color: #323233;
            font-size: 3.73333vw;
        }
        .van-cell{
            color: gray;
        }
        .showHis{
            .van-cell__title{
                overflow:hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
            }
        }
    }
</style>
<style lang="less" scoped>
    .navbar-container{

        .navigation {
            width: 100%;
            margin: 0 auto;
            cursor: pointer;
        }
    }
</style>